import React from 'react';
import { CELL_RENDERERS, StatusIndicator, STATUS_INDICATOR_VARIANTS } from 'cdk-radial';
import { ViewDetails } from './ViewDetails';

const toolTipFields = ['dealer', 'address', 'app', 'api', 'lastModified'];

const headers = {
  dealer: 'Dealer Name',
  address: 'Dealer Address',
  cmf: 'CMF No.',
  app: 'App Name',
  subscriptionStatus: 'Subscription Status',
  api: 'API Name',
  integrationStatus: 'API Status',
  lastModified: 'Last Modified Date',
  configurations: 'Configurations'
};

const variantsMap = {
  active: 'POSITIVE',
  pending: 'WARNING',
  inactive: 'NEGATIVE'
};

const statusStyle = {width: "70px", justifyContent: "center"};

export const Configurations = props => {
  const {
      data: {
        configurations: {
          app,
          api,
          departments,
          apiName
        }
      }
  } = props;

  //can be extended for CPP, Vertical Scoping
  return departments?.length ? <ViewDetails app={app} api={api} departments={departments} apiName={apiName} /> : 'N/A';
};

const columns = [{
    field: 'dealer',
  }, {
    field: 'address',
  }, {
    field: 'cmf',
  },  {
    field: 'app',
  },{
    field: 'subscriptionStatus',
  },{
    field: 'api',
  },{
    field: 'integrationStatus',
  },{
    field: 'lastModified',
  },{
    field: 'configurations',
}];

const Status = ({value}) => 
  <StatusIndicator
    label={value}
    variant={STATUS_INDICATOR_VARIANTS[variantsMap[value]]}
    style={statusStyle}
  />;

const getRenderer = (field, type) => {
  let renderer, framework;
  switch(field) {
    case 'configurations':
      framework = Configurations;
      break;
    case 'subscriptionStatus':
    case 'integrationStatus':
      framework = Status;
      break;   
    default:
      renderer = CELL_RENDERERS.TEXT;
      break;
  };
  return type === 'renderer' ? renderer : framework;
};

export const styledColumns = columns.map(c => {
  const field = c?.field;
  let styledColumn = {
    ...c,
    headerName: headers[field],
    headerClass: 'dealer-integration__header',
    cellClass: 'tooltip-truncate',
    cellRenderer: getRenderer(field, 'renderer'),
    cellRendererFramework: getRenderer(field, 'framework')
  };
  if(toolTipFields.includes(field)) {
    styledColumn = {
      ...styledColumn,
      tooltipField: field
    };
  }
  return styledColumn;
});